const errorStyles = `
  color: hsla(0, 100%, 40%, 1);
  font-size: 0.75rem;
`;

export { errorStyles };
